module.exports = __webpack_public_path__ + "img/type_flatbed.2b8bb18a.jpg";